<template>
  <ion-page>
    <ion-header :translucent="true">
      <HeaderContainer title="" />
    </ion-header>
    <ion-content ref="storyContent" :fullscreen="true">
      <FeedContainer :key="$route.fullPath" :scrollContainer="scrollElement" streamName="story" filter="" :imageid="imageId" :stories="storyData" v-model:refreshFeed="refreshFeed" v-model:networkTimeout="timeout" />
      <p>&nbsp;</p>
      <p>&nbsp;</p>
    </ion-content>  
  </ion-page>
</template>
<script>
import { IonPage, IonContent, IonHeader } from '@ionic/vue';
import FeedContainer from '@/components/FeedContainer.vue';
import HeaderContainer from '@/components/HeaderContainer.vue';

export default {
  name: 'StoryView',
  components: {
    FeedContainer,
    IonContent,
    IonPage,
    HeaderContainer,
    IonHeader
  },
  data() {
    return {
      refreshFeed: false,
      timeout: false,
      scrollElement: null,
    }
  },
  async ionViewDidEnter() {
    //console.log('ion did enter load');
    this.loadStory();
  },
  async mounted() {
    this.scrollElement = await this.$refs.storyContent.$el.getScrollElement();
  },
  methods: {
    async loadStory() {
      /* if (this.$route.params.imageid != null) {
        this.imageId = this.$route.params.imageid;
      } else if (this.$route.params.hashid != null) {
        this.imageId = atob(this.$route.params.hashid);
      } */
      /* if(this.$store.state.pikstream.storyResponseData[this.imageId] != null){
        this.$store.commit('pikstream/setStoryLoading', false);
      } */

      if (this.$store.state.pikstream.storyResponseData[this.imageId] == null) {
        //console.log('story view get stream', this.imageId);
        this.$store.commit('pikstream/setStoryLoading', true);
        let response = await this.$store.dispatch("pikstream/getStream", {
          streamName: 'story',
          filter: '',
          imageid: this.imageId,
          storyid: '',
          total_list: this.$store.state.pikstream.totalList.story,
          last_id: this.$store.state.pikstream.lastId.story,
          userid: ''
        });
        //console.log(response, 'story data');
        if (response.error != undefined) {
          //console.log('there was an error1', response.error);
          this.$router.replace({ name: 'PageNotExist'});
          //this.timeout = true;
        }
      }
    }
  },
  computed: {
    storyData() {
      if (this.$store.state.pikstream.storyResponseData[this.imageId] != null) {
        return [this.$store.state.pikstream.storyResponseData[this.imageId]];
      }
      return [];
    },
    imageId() {
      if (this.$route.params.imageid != null) {
        return this.$route.params.imageid;
      } else if (this.$route.params.hashid != null) {
        return atob(this.$route.params.hashid);
      }
      return '';
    }

  }
}
</script>
